import { render } from "./storeSettingsView.vue?vue&type=template&id=4485a056"
import script from "./storeSettingsView.vue?vue&type=script&lang=js"
export * from "./storeSettingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__